import {
  ResponsiveContainer,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  Cell,
} from "recharts";

import { getScoreColor } from "../utils/scoreColor";

function AnalysisChart({ analysis }) {
  const data = [
    {
      name: "Relevance",
      value: analysis.relevance.score,
    },
    {
      name: "Quality",
      value: analysis.quality.score,
    },
  ];

  return (
    <ResponsiveContainer width="100%" height={320}>
      <BarChart data={data}>
        <XAxis dataKey="name" />
        <YAxis domain={[0, 100]} />
        <Tooltip />

        <Bar dataKey="value">
          {data.map((entry) => (
            <Cell key={entry.name} fill={getScoreColor(entry.value)} />
          ))}
        </Bar>
      </BarChart>
    </ResponsiveContainer>
  );
}

export default AnalysisChart;
